// Select elements
const team_select_btn = document.querySelector('#team_select');
const team_season_menu = document.querySelector('#team_list');
const team_options = document.querySelectorAll('#team_list li');

// Track state for menu and focus
let isMenuOpen = false;
let currentIndex = (team_options.length - 1); // To track the currently focused option

// Toggle the menu visibility
function toggleMenu() {
  const isOpen = team_season_menu.classList.contains('active');
  if (!isOpen) {
    // Open the menu
    team_season_menu.classList.add('active');
    team_select_btn.setAttribute('aria-expanded', 'true');
    isMenuOpen = true;
    focusOption();
  } else {
    // Close the menu
    team_season_menu.classList.remove('active');
    team_select_btn.setAttribute('aria-expanded', 'false');
    isMenuOpen = false;
  }
}

// Handle clicking outside the menu to close it
function closeMenuOnClickOutside(event) {
  const isClickInside = team_select_btn.contains(event.target) || team_season_menu.contains(event.target);
  if (!isClickInside) {
    team_season_menu.classList.remove('active');
    team_select_btn.setAttribute('aria-expanded', 'false');
    isMenuOpen = false;
  }
}

// Close the menu and select the value when an option is clicked
function onOptionClick() {
  team_options.forEach(option => {
    option.addEventListener('click', function(event) {
      const selectedValue = event.target.innerText; // Get the text of the selected option
      team_select_btn.innerText = selectedValue; // Update button text with selected option
      team_season_menu.classList.remove('active'); // Close the menu after selection
      team_select_btn.setAttribute('aria-expanded', 'false');
      focusOption()
      isMenuOpen = false;
    });
  });
}

// Handle keyboard events for accessibility
function handleKeyPress(event) {
  const { key } = event;
  console.log(event);

  // Open the menu with Enter or Down Arrow key on button
  if (!isMenuOpen && (key === 'Enter' || key === 'ArrowDown')) {
    toggleMenu();
    return;
  }

  if (isMenuOpen) {
    switch (key) {
      case 'ArrowDown':
        // Move focus down
        moveFocusDown();
        break;
      case 'ArrowUp':
        // Move focus up
        moveFocusUp();
        break;
      case 'Enter':
        // Select the focused option
        selectOption(event.target);
        break;
      case 'Escape':
        // Close the menu
        closeMenu();
        break;
      case 'Tab':
        // Allow tabbing through the options, let the browser handle it
        return;
      default:
        break;
    }
  }
}

// Move the focus down through the options
function moveFocusDown() {
  if (currentIndex < team_options.length - 1) {
    currentIndex++;
  } else {
    currentIndex = 0; // Wrap to the first option
  }
  focusOptionKeyPress();
}

// Move the focus up through the options
function moveFocusUp() {
  if (currentIndex > 0) {
    currentIndex--;
  } else {
    currentIndex = team_options.length - 1; // Wrap to the last option
  }
  focusOptionKeyPress();
}

// Focus the currently selected option
function focusOption() {
  team_options.forEach((option, index) => {
    option.classList.remove('current');
    if ((option.innerText === team_select_btn.innerText)) {
      currentIndex = index;
      option.classList.add('current');
      option.focus();
    }
  });
}

function focusOptionKeyPress() {
  if (currentIndex >= 0 && currentIndex < team_options.length) {
    team_options.forEach((option, index) => {
      option.classList.remove('current');
      if (index === currentIndex) {
        option.classList.add('current'); // Add the focus class
        option.focus(); // Focus the current option
      }
    });
  }
}

// Select the currently focused option
function selectOption(option) {
  const selectedOption = option;
  const selectedValue = selectedOption.innerText;
  team_select_btn.innerText = selectedValue; // Update the button text

  // Find Index
  team_options.forEach((option, index) => {
    if (option.innerText === team_select_btn.innerText) {
      currentIndex = index;
    }
  });
  
  closeMenu(); // Close the menu
}

// Close the menu
function closeMenu() {
  team_season_menu.classList.remove('active');
  team_select_btn.setAttribute('aria-expanded', 'false');
  isMenuOpen = false;
  currentIndex = -1; // Reset focus index
}

// Initialize event listeners
function init() {
  team_select_btn.addEventListener('click', toggleMenu); // Open/close the menu
  onOptionClick();
  document.addEventListener('click', closeMenuOnClickOutside); // Close menu on click outside
  team_select_btn.addEventListener('keydown', handleKeyPress); // Handle keyboard interactions
  team_season_menu.addEventListener('keydown', handleKeyPress); // Allow keys within the dropdown
}

init();
